import { IonCheckbox, IonLabel } from '@ionic/react'
import { useQueryClient } from '@tanstack/react-query'
import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/actions/Button'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { backendCall } from '../../modules/backendApi'
import { ConsumptionElementSlideStateType } from '../types/types'
import { consumptionElementOptions } from './OnboardingTypeOptions'

interface Props {
	setOnInteractionFunc?: React.Dispatch<React.SetStateAction<(() => void) | undefined>>
	state: [
		ConsumptionElementSlideStateType,
		React.Dispatch<React.SetStateAction<ConsumptionElementSlideStateType>>,
	]
	saveButton?: boolean
}

const ConsumptionElementSlide: React.FC<Props> = ({
	state,
	setOnInteractionFunc,
	saveButton = false,
}) => {
	const object = useContext(ObjectContext)
	if (!object) return null

	const queryClient = useQueryClient()

	const { t, i18n } = useTranslation('pages_onboarding')

	const submit = async () => {
		try {
			await Promise.all([
				...Array.from(state[0]).map(element =>
					backendCall.add('consumptionElements', {
						name: element.name,
						type: element.type,
						objectId: object.id,
						custom: false,
					})
				),

				backendCall.add('consumptionElements', {
					name: 'kodinkoneet',
					objectId: object.id,
					custom: false,
				}),
			])

			queryClient.invalidateQueries('objectOptions' as any)
		} catch (error) {
			console.error('Failed to add consumption elements', error)
		}
	}

	useEffect(() => {
		if (setOnInteractionFunc) setOnInteractionFunc(() => submit)
	}, [state[0]])

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>
				{t('consumptionElementSlide.onkoKohteessaSeuraavia')}
			</h1>
			<div className='options-container'>
				{consumptionElementOptions(i18n.language as 'fi' | 'en').map(element => (
					<div key={element.name} className='option'>
						<IonCheckbox
							className='dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
							checked={Array.from(state[0]).some(el => el.name === element.name)}
							onIonChange={e => {
								const checked = e.detail.checked
								if (checked) {
									state[1](prev => new Set(prev.add(element)))
								} else {
									state[1](prev => {
										const newSelected = new Set(prev)
										Array.from(newSelected).forEach(el => {
											if (el.name === element.name) {
												newSelected.delete(el)
											}
										})
										return newSelected
									})
								}
							}}
						/>
						<IonLabel className='text-text-dark dark:text-white'>{element.label}</IonLabel>
					</div>
				))}
			</div>
			{saveButton && (
				<div className='buttons-container'>
					<Button onClick={submit}>{t('tallenna', { ns: 'common' })}</Button>
				</div>
			)}
		</>
	)
}

export default ConsumptionElementSlide
